var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoUncertain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,46c-12.13,0-22-9.87-22-22S11.87,2,24,2s22,9.87,22,22-9.87,22-22,22Zm0-40C14.08,6,6,14.07,6,24s8.07,18,18,18,18-8.07,18-18S33.93,6,24,6Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.01,30.64c.3,0,.6,.05,.87,.16,.28,.12,.53,.3,.74,.51,.23,.23,.39,.49,.51,.76s.18,.58,.18,.88-.07,.6-.18,.88-.28,.53-.51,.76c-.85,.86-2.39,.86-3.24,0-.21-.23-.39-.49-.51-.76-.12-.28-.16-.58-.16-.88s.04-.6,.16-.88c.11-.28,.3-.53,.51-.76,.21-.21,.46-.39,.76-.51,.28-.12,.57-.16,.87-.16Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,29.23c-1.11,0-2-.89-2-2v-1.19c.2-2.46,1.82-3.43,3.01-4.14,.71-.43,1.33-.79,1.77-1.42,.7-1.01,.72-1.41,.68-2.08-.07-1.29-1.36-2.16-2.26-2.3-1.16-.18-2.13,.02-2.81,.56-.65,.52-.91,1.23-.94,1.73v1.08c0,1.11-.89,2-2,2s-2-.89-2-2v-1.21c.12-1.87,1.02-3.59,2.43-4.72,1.1-.88,3.02-1.84,5.93-1.4,2.61,.4,5.47,2.65,5.65,6.04,.08,1.48-.13,2.76-1.39,4.57-.93,1.34-2.13,2.05-3.01,2.57-.96,.57-1.05,.68-1.06,.87v1.02c0,1.11-.89,2-1.99,2Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUncertain);
export default __webpack_public_path__ + "static/media/ico-uncertain.be64bc8850819e88394bc8529853ddef.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;